import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Badge } from '@/components/ui/badge';
import { type BatonEvent } from '@/lib/queries';
import { formatEventType } from '@/lib/baton-format';

/**
 * One baton event, shared by the per-baton Activity tab and the Overview
 * page's cross-baton activity log. `showBaton` adds a link to the owning
 * baton (used by the cross-baton view; the per-baton tab omits it).
 */
export function BatonEventRow({
  event,
  showBaton,
}: {
  event: BatonEvent;
  showBaton?: boolean;
}) {
  return (
    <li className="flex items-start justify-between gap-3 border-b py-2 last:border-0">
      <div className="min-w-0 space-y-0.5">
        <div className="flex flex-wrap items-center gap-2">
          <Badge variant="secondary">{formatEventType(event.eventType)}</Badge>
          {showBaton ? (
            <Link
              to={`/dashboard/batons/${encodeURIComponent(event.batonId)}`}
              className="truncate text-sm font-medium hover:underline"
            >
              {event.batonName ?? event.batonId}
            </Link>
          ) : null}
        </div>
        <div className="text-xs text-muted-foreground">
          {event.actorType}
          {event.actorId ? ` · ${event.actorId.slice(0, 12)}…` : ''}
        </div>
      </div>
      <time className="whitespace-nowrap text-xs text-muted-foreground">
        {format(parseISO(event.occurredAt), 'MMM d, HH:mm')}
      </time>
    </li>
  );
}
